import { createApp } from "@shopify/app-bridge";
import config from "config";

if(new URLSearchParams(window.location.search).get("host")){
    localStorage.setItem('shopify_host', new URLSearchParams(window.location.search).get("host"));
    localStorage.setItem('shopify_shop', new URLSearchParams(window.location.search).get("shop"));
    localStorage.setItem('shopify_session', new URLSearchParams(window.location.search).get("session"));
}

const shopifyAppConfig = {
    // The client ID provided for your application in the Partner Dashboard.
    apiKey: config.shopifyClientId,
    // The host of the specific shop that's embedding your app. This value is provided by Shopify as a URL query parameter that's appended to your application URL when your app is loaded inside the Shopify admin.
    host: localStorage.getItem('shopify_host'),
    forceRedirect: true
};

export {
    shopifyAppConfig
}